import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Styles from './Icons.scss';

export const MarkerIcon = ({ width = 15, height = 20, className }) => (
  <svg
    className={cn(Styles.icon, className)}
    width={width}
    height={height}
    dangerouslySetInnerHTML={{ __html: '<use xlink:href="#pin" />' }}
  />
);
MarkerIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  height: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};
